import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { subscribeNewsletter } from '@/lib/api';
import { toast } from 'sonner';
import { ArrowRight, Loader2 } from 'lucide-react';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [gdprConsent, setGdprConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!gdprConsent) {
      toast.error('Accetta la privacy policy per continuare');
      return;
    }
    
    setLoading(true);
    try {
      await subscribeNewsletter(email, gdprConsent);
      toast.success('Benvenuto nell\'Inner Circle!');
      setEmail('');
      setGdprConsent(false);
    } catch (error) {
      const message = error.response?.data?.detail || 'Errore durante l\'iscrizione';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="newsletter-form">
      <div className="flex gap-3">
        <Input
          type="email"
          placeholder="La tua email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="flex-1 bg-white border-stone-200 rounded-full px-6 py-6 font-body"
          data-testid="newsletter-email-input"
        />
        <Button
          type="submit"
          disabled={loading}
          className="bg-night text-ivory hover:bg-stone-800 rounded-full px-6"
          data-testid="newsletter-submit-button"
        >
          {loading ? (
            <Loader2 className="animate-spin" size={20} />
          ) : (
            <ArrowRight size={20} />
          )}
        </Button>
      </div>
      
      <div className="flex items-start gap-3">
        <Checkbox
          id="gdpr"
          checked={gdprConsent}
          onCheckedChange={setGdprConsent}
          className="mt-0.5"
          data-testid="newsletter-gdpr-checkbox"
        />
        <Label htmlFor="gdpr" className="font-body text-xs text-stone-500 leading-relaxed cursor-pointer">
          Accetto la <a href="/privacy" className="underline hover:text-night">Privacy Policy</a> e acconsento al trattamento dei miei dati per ricevere comunicazioni da La Villa.
        </Label>
      </div>
    </form>
  );
}
